import React from 'react';
import PropTypes from 'prop-types';

const SvgRedo = ({ active, ...props }) => {
    const fillColor = active ? '#128383' : '#EAEBF0';
    const strokeColor = active ? '#ffffff' : '#343A72';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="22" fill="none" viewBox="0 0 26 22" {...props}>
            <path
                fill={fillColor}
                fillRule="evenodd"
                stroke={strokeColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="m25.2 7.993-3.452 3.347-3.758 3.64v-3.897C8.604 11.083 1 15.691 1 21.38 1 12.277 8.604 4.902 17.99 4.902V1l4.682 4.54L25.2 7.993Z"
                clipRule="evenodd"
            />
        </svg>
    );
};
SvgRedo.propTypes = {
    active: PropTypes.bool,
};
SvgRedo.defaultProps = {
    active: false,
};

export default SvgRedo;
